<template lang="pug">
.income-list-page.flex.column.align-center
  .content.flex.column.align-stretch.pt-40.gap-20
    .title.font-size-20.bold 薪資歷史紀錄
    .danger-color(v-if="loadFailed") 薪資歷史紀錄載入失敗，請稍後再試
    .empty.text-secondary(v-else-if="loaded && list.length === 0") 尚無薪資歷史紀錄
    .years.flex.column
      .year.flex.column.gap-8(v-for="l in list", :key="l.year")
        .year-title.flex.row.align-center.pl-12.pr-12.gap-8.clickable(
          @click="toggleShow(l)")
          i.el-icon-date
          span {{ l.year }}
        template(v-if="l.show")
          .month.flex.row.align-center.pl-12.pr-12.clickable(
            @click="goPayslipMonth(d)"
            v-for="d in l.data")
            .content.bold {{ d.year }}年 {{ d.month }}月
              el-tag.ml-8(v-if="d.confirm_status === 'wrong_amount'", size="mini", type="danger") 已標記錯誤，待蛹之生確認
</template>

<script>
import {
  GetPayslips,
} from '@/site/professional/api/accounting';

// 薪資歷史列出已確認與已標記錯誤（待蛹之生聯繫確認）的月份
const historyStatus = ['confirmed', 'wrong_amount'];

export default {
  data() {
    return {
      list: [],
      loaded: false,
      loadFailed: false,
    };
  },
  methods: {
    goPayslipMonth(d) {
      this.$router.push(`/payment/${d.year}/${d.month}`);
    },
    toggleShow(l) {
      // eslint-disable-next-line no-param-reassign
      l.show = !l.show;
      this.$forceUpdate();
    },
    loadData() {
      this.$execWithLoading(async () => {
        const rsp = (await GetPayslips())
          .filter((p) => historyStatus.includes(p.confirm_status))
          .sort((a, b) => (b.year - a.year) || (b.month - a.month));
        const yearMap = {};
        const list = [];
        rsp.forEach((payslip) => {
          if (!yearMap[payslip.year]) {
            const l = {
              year: payslip.year,
              data: [],
              show: true,
            };
            list.push(l);
            yearMap[payslip.year] = l;
          }
          yearMap[payslip.year].data.push(payslip);
        });
        this.list = list;
        this.loaded = true;
        this.loadFailed = false;
      }, (e) => {
        this.loadFailed = true;
        this.$showAxiosException('載入薪資歷史紀錄失敗', e);
      });
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>

<style lang="scss" scoped>
.income-list-page {
  .content {
    width: calc(100vw - 40px);
    max-width: 600px;
    .years {
      .year-title {
        flex: 0 0 40px;
        background: white;
        border-radius: 4px;
      }
      .month {
        flex: 0 0 40px;
        background: white;
        border-radius: 4px;
      }
    }
  }
}
</style>
